<template>
  <v-menu open-on-click :close-delay="0" :open-delay="0" :open-on-hover="openOnHover" :open-on-focus="false" transition="none" theme="light">
    <template v-slot:activator="{ props }">
      <div v-bind="props" v-if="atLeastOneChildIsAccessible()" class="tw:flex tw:h-full">
        <v-btn variant="text" :class="titleClass" :data-test="testKey" class="tw:text-xs tw:h-full tw:text-white">
          <component :is="icon" v-if="icon" :size="16" class="tw:mr-2" />
          {{ title }}
        </v-btn>
        <div v-if="showBorder" class="tw:bg-primary tw:w-px tw:h-1/2 tw:self-center"/>
      </div>
    </template>

    <v-list density="compact">
      <div v-for="{ title, to, href, icon, subtitle, divider, click, download, testKey, disabled, hidden, chipTitle } in links" :key="title">
        <v-divider v-if="divider" />
        <v-list-item v-else-if="hasAccess(to) && !hidden"
          :disabled="disabled"
          exact
          :to="to" :href="href"
          :download="download"
          v-on="click ? { click } : {}"
          :data-test="testKey"
          :title="title"
          :subtitle="subtitle"
          nav
          class="tw:px-3"
        >
          <template v-if="icon" v-slot:prepend>
            <component :is="icon" :size="16" class="" />
          </template>

          <template v-if="chipTitle" v-slot:append>
            <div class="tw:badge tw:badge-sm tw:bg-blue-200 tw:badge-accent">{{ chipTitle }}</div>
          </template>
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import store from '@/store';
import { AreAllRouteGroupsAllowed } from '@/utilities/AuthUtils';

export default {
  name: 'NavMenuItem',
  props: {
    titleClass: String,
    testKey: String,
    icon: Object,
    title: String,
    links: Array,
    openOnHover: Boolean,
    showBorder: Boolean,
    chipTitle: String,
  },
  methods: {
    hasAccess(to) {
      const user = store.state.user;
      if (!user) {
        return false;
      }

      if (AreAllRouteGroupsAllowed(user)) {
        return true;
      }

      if (!to) {
        return true;
      }

      const resolved = this.$router.resolve(to);
      if (!resolved) {
        return false;
      }

      const {routeGroup} = resolved.meta;
      return (user.allowedRouteGroups || []).includes(routeGroup);
    },
    atLeastOneChildIsAccessible() {
      return this.links.map(l => !l.hidden && this.hasAccess(l.to)).includes(true);
    }
  }
};
</script>
